<form [formGroup]="form" *ngIf="!simpleMode">
  <input type="text" placeholder="Search Format" formControlName="search" appAutofocus />
  <app-svg src="/assets/icons/search.svg"></app-svg>
</form>

<div class="conversion-format-container">
  <ng-container *ngIf="form.value.search; else notSearching">
    <div class="buttons">
      <ng-container *ngIf="formats$ | async as formats">
        <div *ngIf="!formats.length" class="no-formats-found">No formats found for "{{ form.value.search }}"</div>
        <app-conversion-format-select-menu-item
          *ngFor="let format of formats"
          [format]="format"
          [fromFormat]="fromFormat"
          [toFormat]="toFormat"
          [mode]="mode"
          [linkMode]="linkMode"
          (formatSelected)="formatSelected.emit(format)"
          [active]="
            (mode === 'to' && format.slug === toFormat?.slug) || (mode === 'from' && format.slug === fromFormat?.slug)
          "
        ></app-conversion-format-select-menu-item>
      </ng-container>
    </div>
  </ng-container>

  <ng-template #notSearching>
    <ng-container *ngIf="!simpleMode && popularFormats$ | async as popularFormats">
      <h3 class="menu-list-title">POPULAR</h3>
      <div class="buttons">
        <app-conversion-format-select-menu-item
          *ngFor="let format of popularFormats"
          [format]="format"
          [fromFormat]="fromFormat"
          [toFormat]="toFormat"
          [mode]="mode"
          [linkMode]="linkMode"
          (formatSelected)="formatSelected.emit(format)"
          [active]="
            (mode === 'to' && format.slug === toFormat?.slug) || (mode === 'from' && format.slug === fromFormat?.slug)
          "
        ></app-conversion-format-select-menu-item>
      </div>
    </ng-container>
    <ng-container *ngIf="formats$ | async as allFormats">
      <h3 class="menu-list-title" *ngIf="!simpleMode">ALL FORMATS</h3>
      <div class="buttons">
        <app-conversion-format-select-menu-item
          *ngFor="let format of allFormats"
          [format]="format"
          [fromFormat]="fromFormat"
          [toFormat]="toFormat"
          [mode]="mode"
          [linkMode]="linkMode"
          (formatSelected)="formatSelected.emit(format)"
          [active]="
            (mode === 'to' && format.slug === toFormat?.slug) || (mode === 'from' && format.slug === fromFormat?.slug)
          "
        ></app-conversion-format-select-menu-item>
      </div>
    </ng-container>
  </ng-template>
</div>
